import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { MapService, MapClickEvent, MoteEventService } from '../../providers';
import { MoteEvent, MoteEventType } from '../../models';
import { AutoSubOnDestroy, AutoSub } from '../../providers/auto-sub';

@AutoSubOnDestroy()
@Component({
    selector: 'motes-map',
    templateUrl: './motes-map.component.html',
    styleUrls: ['./motes-map.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class MotesMapComponent {
    @Input() set initMap(doInitMap: boolean) {
        this.init(doInitMap);

    }

    @Input() set motes(motes) {
        this.mapService.awaitTilesLoaded().then(() => {
            this.mapService.setMotes(motes);
        })
    }

    @Output() mapClick: EventEmitter<MapClickEvent> = new EventEmitter();
    @Output() mapReady: EventEmitter<any> = new EventEmitter()

    public showFakeMap: boolean = false;

    constructor(private mapService: MapService, private moteEvenService: MoteEventService) {
        //console.log("Map constructor");
    }

    private init(doInitMap: boolean) {
        if(!doInitMap) {
            this.showFakeMap = true;
            return;
        }
    }

    public ngAfterViewInit() {
        this.mapService.init().then((res) => {
            // Map initialized
            AutoSub(this).reg['moteEvents'] = this.moteEvenService.watchMoteEvents().subscribe(ev => this.handleMoteEvent(ev));
            AutoSub(this).reg['onClick'] = this.mapService.watchMapClick().subscribe(ev => this.mapClick.emit(ev));
            this.mapReady.emit(res);
        });
    }

    private handleMoteEvent(ev: MoteEvent) {
        switch(ev.type) {
            case MoteEventType.NAVIGATE_TO_MOTE:
                this.mapService.flyToMote(ev.mote);
                break;
        }
    }
}
